// Kept free of Vue and `@/` imports so it can run under `node --test`.
import { userCan } from "../../services/helpers.js";

export const MY_WHOLESALE_NEEDS = "/wholesale-needs";
export const BUYER_NEEDS = "/wholesale-needs/buyer-needs";

/** The companies store's copy, which the rest of the app shows; the user's own copy until that store has loaded. */
function currentSubscription(store) {
  return store.getters["companies/currentCompany"].subscription ?? store.state.auth.user?.current_company?.subscription;
}

/** The Wholesale Needs pages the user may open in their current company, the default first. */
export function wholesaleNeedsPages(store) {
  const { user } = store.state.auth;
  const subscription = currentSubscription(store);

  return [
    ["buyer", "seller"].includes(subscription) && userCan("manage wholesale needs", user) && MY_WHOLESALE_NEEDS,
    subscription === "seller" && userCan("update buyers", user) && BUYER_NEEDS,
  ].filter(Boolean);
}

/** Route guard result for opening `page`: undefined lets the user in, otherwise where to send them. */
export function wholesaleNeedsRedirect(page, store, to) {
  const pages = wholesaleNeedsPages(store);
  if (pages.includes(page)) {
    return undefined;
  }
  return pages[0] ?? { path: "/not-authorized", query: { redirect: to.fullPath } };
}
